export interface BaseRegionResponse {
  id: number
  name: string
  volunteerHours?: number | null
  latitude1?: number | null
  latitude2?: number | null
  longitude1?: number | null
  longitude2?: number | null
  baseLayoutConfig?: unknown
  /** Default capacity for calendar weeks (STM). Default 20. */
  defaultCapacity?: number | null
  /** Week start day: 0=Sun, 1=Mon, ..., 6=Sat. Default 6 (Saturday). */
  startDay?: number | null
}

export function unwrapBaseRegionResponse(payload: any): BaseRegionResponse | null {
  if (!payload) return null
  if (payload.data) {
    return payload.data as BaseRegionResponse
  }
  return payload as BaseRegionResponse
}
